import React from "react";
import { CategoriesTemplate } from "../../../components/templates";

function Categories() {
  return <CategoriesTemplate />;
}

export default Categories;
